module.exports = __webpack_public_path__ + "static/media/cardImageFallback.4410cf6d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/common/assets/images/cardImageFallback.jpg
// module id = 524
// module chunks = 2